import { render } from "./NotFound.vue?vue&type=template&id=4b14dac0&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=4b14dac0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4b14dac0"

export default script